/* ═══════════════════════════════════════════════════════════════
   REUNITED — Shop grid + product page behaviors (v2)
   Grid: entrance + expand-to-product transition (image tiles).
   PDP: scroll-snap gallery with arrows, dots, thumbnail sync,
        opt-in video slides, accordions, variant price, floating bar.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var DURATION = 600;
  var isMob = function () { return window.innerWidth < 768; };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ─────────────────────────────────────────────────────────────
     SHOP GRID — entrance only. Product cards navigate directly (no
     morphing transition), so images are never distorted; the product
     page fades its own gallery in on arrival.
     ───────────────────────────────────────────────────────────── */
  var entry = document.getElementById('ru-shop-entry');
  if (entry) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { entry.classList.add('is-in'); });
    });
  }

  /* ─────────────────────────────────────────────────────────────
     PRODUCT PAGE
     ───────────────────────────────────────────────────────────── */
  var detail = document.getElementById('ru-pdp-detail');
  if (detail) {
    setTimeout(function () { detail.classList.add('is-in'); }, 100);

    /* ── Gallery carousel ── */
    var gallery = document.getElementById('ru-gallery');
    var track = document.getElementById('ru-gal-track');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-gal-slide]')) : [];
    var dotsWrap = document.getElementById('ru-gal-dots');
    var prevBtn = gallery ? gallery.querySelector('[data-gal-prev]') : null;
    var nextBtn = gallery ? gallery.querySelector('[data-gal-next]') : null;
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-gal-thumb]'));
    var current = 0;

    function perView() {
      if (!gallery) return 1;
      if (isMob()) return 1;
      return parseInt(gallery.getAttribute('data-perview') || '2', 10) === 1 ? 1 : 2;
    }
    function maxIndex() { return Math.max(0, slides.length - perView()); }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      slides.forEach(function (_, i) {
        var d = document.createElement('span');
        d.className = 'ru-gal-dot' + (i === current ? ' is-active' : '');
        dotsWrap.appendChild(d);
      });
    }

    function syncVideos() {
      slides.forEach(function (slide, i) {
        var v = slide.querySelector('video');
        if (!v) return;
        var visible = i >= current && i < current + perView();
        if (visible) {
          slide.classList.add('is-playing');
          try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
        } else {
          slide.classList.remove('is-playing');
          try { v.pause(); } catch (e) {}
        }
      });
    }

    function setActive(i, scroll) {
      current = Math.max(0, Math.min(i, maxIndex()));
      if (scroll && track && slides[current]) {
        track.scrollTo({ left: slides[current].offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      }
      if (dotsWrap) {
        Array.prototype.forEach.call(dotsWrap.children, function (d, di) {
          d.classList.toggle('is-active', di === current);
        });
      }
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', parseInt(t.getAttribute('data-index'), 10) === current);
      });
      if (prevBtn) prevBtn.toggleAttribute('disabled', current <= 0);
      if (nextBtn) nextBtn.toggleAttribute('disabled', current >= maxIndex());
      syncVideos();
    }

    if (track && slides.length) {
      buildDots();
      setActive(0, false);

      var scrollTimer = null;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var sl = track.scrollLeft;
          var best = 0, bestDist = Infinity;
          slides.forEach(function (slide, i) {
            var d = Math.abs(slide.offsetLeft - sl);
            if (d < bestDist) { bestDist = d; best = i; }
          });
          setActive(best, false);
        }, 90);
      }, { passive: true });

      if (prevBtn) prevBtn.addEventListener('click', function () { setActive(current - 1, true); });
      if (nextBtn) nextBtn.addEventListener('click', function () { setActive(current + 1, true); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); setActive(current - 1, true); }
        if (e.key === 'ArrowRight') { e.preventDefault(); setActive(current + 1, true); }
      });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          setActive(parseInt(t.getAttribute('data-index'), 10), true);
        });
      });
      window.addEventListener('resize', function () { setActive(current, false); });
      // tap a video slide to toggle sound off/on pause
      slides.forEach(function (slide) {
        var v = slide.querySelector('video');
        if (!v) return;
        slide.addEventListener('click', function () {
          if (v.paused) { try { v.play(); } catch (e) {} slide.classList.add('is-playing'); }
          else { v.pause(); slide.classList.remove('is-playing'); }
        });
      });
    }

    /* ── Accordions (respect server-rendered is-open) ── */
    document.querySelectorAll('.ru-acc2-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.ru-acc2');
        if (item) item.classList.toggle('is-open');
      });
    });

    /* ── Variant select → price ── */
    var vsel = document.getElementById('ru-pdp-variant');
    var price = document.getElementById('ru-pdp-price');
    if (vsel && price) {
      vsel.addEventListener('change', function () {
        var opt = vsel.options[vsel.selectedIndex];
        if (opt && opt.dataset.price) price.textContent = opt.dataset.price;
      });
    }

    /* ── Mobile floating bar ── */
    var cta = document.getElementById('ru-pdp-add');
    var floating = document.getElementById('ru-pdp-floating');
    var floatAdd = document.getElementById('ru-pdp-floating-add');
    var form = document.getElementById('ru-pdp-form');
    if (cta && floating) {
      var onScroll = function () {
        var r = cta.getBoundingClientRect();
        floating.classList.toggle('is-show', r.bottom < 0 && isMob());
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }
    if (floatAdd && form) {
      floatAdd.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }
  }
})();
